import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  .MuiTabs-scroller {
    background-color: ${props => props.theme.colors.background.secondary};
  }
`
